"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const borders = {
    radius: {
        base: 4,
    },
};
exports.default = borders;
